<!--*ngIf="currentChatConversation.titleAvatarInfo || currentChatConversation.isGroupConversation"-->
<div class="messaging-header flex flex-row justify-start items-center">

  <button mat-icon-button class="m-r-3" (click)="navigateToHelpAndSupport()"
          particleAnalytics
          analyticsCategory="conversation"
          analyticsAction="left-btn">
    <i class="far fa-chevron-left"></i>
  </button>

  <div class="flex flex-row justify-start items-center full-grow-no-shrink-no-basis">

    <collaboration-avatar [gravatarInfo]="true"
                          [showGroupAvatar]="currentChatConversation && currentChatConversation.isGroupChat">
    </collaboration-avatar>

    <div class="full-grow-no-shrink-no-basis"><strong>Orbitax</strong>
    </div>

    <div>

    </div>

  </div>

</div>

<div #messagecontainer class="rest-of simple-scroll">

  <div *ngFor="let messageObj of systemMessages" class="message-container"
       @fadeIn (mouseover)="messageObj.hover=true" (mouseleave)="messageObj.hover=false">

    <div *ngIf="!messageObj.type || messageObj.type==='Speech'">
      <div *ngIf="messageObj.isDeleted" class="deleted-text message-box me flex flex-row justify-start items-start">
        <i class="far fa-exclamation-circle"></i><span>This message has been removed</span>
      </div>
      <div
        *ngIf="!messageObj.isDeleted && (messageObj.systemMessageType === 'NON_SYSTEM_MESSAGE' || messageObj.systemMessageType === 0)"
        [ngClass]="messageObj.isMine ? 'message-box me' : 'message-box others'">
        <div class="flex flex-col">
          <!--<span>{{messageObj.createdBy.firstName}}:</span>-->
          <span
            [ngClass]="messageObj.isMine ? 'hideBlock' : 'showBlock sender'">{{messageObj.createdBy?.firstName}} {{messageObj.createdBy?.lastName}}</span>
          <span [innerHtml]="messageObj.message"></span>
          <span *ngIf="messageObj.isEdited" class="edited">(Edited)</span>
          <button mat-icon-button [matMenuTriggerFor]="msgMenu2"
                  [style.visibility]="messageObj.isTemporary? 'hidden': 'visible'"
                  class="reply-menu"
                  particleAnalytics
                  analyticsCategory="conversation"
                  analyticsAction="more-btn">
            <i class="fal fa-ellipsis-h"></i>
          </button>
          <mat-menu #msgMenu2="matMenu" [overlapTrigger]="false">
            <button mat-menu-item *ngIf="messageObj.isMine" (click)="editMessage(messageObj)">
              <span>Edit</span>
            </button>
            <button mat-menu-item (click)="removeMessage(messageObj, true)"
                    *ngIf="messageObj.isMine">
              <span>Delete Message</span>
            </button>
          </mat-menu>
        </div>
        <div class="flex flex-row justify-end items-center">

        <span class="timing">
          {{messageObj.createdDate | date:'medium'}}
        </span>
          <!--        <span (click)="removeMessage(messageObj)" class="trash"
                          [ngStyle]="{visibility: messageObj.isMine && messageObj.hover==true  ? 'visible' : 'hidden' }">
                    <i class="fal fa-trash-alt"></i>
                  </span>-->

        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-col">
    <div *ngIf="!this.ticketsSelectorControl.value" class="flex flex-col">
      <span class="dropdown-issue-title m-b-5">This is a new issue</span>
      <mat-form-field appearance="outline" class="flex-0-0-100">
        <mat-label>Select Category</mat-label>
        <mat-select [formControl]="newTaskTypeControl" required>
          <mat-option *ngFor="let issue of newIssueTypes" [value]="issue">
            {{issue}}
          </mat-option>
        </mat-select>

      </mat-form-field>
    </div>
    <div *ngIf="myOpenSupportTickets && myOpenSupportTickets.length && !this.newTaskTypeControl.value">
      <span class="or" *ngIf="!this.ticketsSelectorControl.value">Or</span>
      <div class="flex flex-col">
        <span class="dropdown-issue-title m-b-5">This is an existing issue</span>
        <mat-form-field appearance="outline" class="flex-0-0-100">

          <mat-label>Select Ticket</mat-label>

          <mat-select [formControl]="ticketsSelectorControl" required>
            <mat-option *ngFor="let ticket of myOpenSupportTickets" [value]="ticket">
              {{ticket.displayTitle}}
            </mat-option>
          </mat-select>

        </mat-form-field>
      </div>

      <!--      <button mat-button class="common-button" (click)="openOldTask()"
                    *ngIf="ticketsSelectorControl && ticketsSelectorControl.value"
                    particleAnalytics
                    analyticsCategory="support-chat"
                    analyticsAction="open-existing-ticket"
            >Open existing ticket
            </button>-->
    </div>

  </div>
  <div *ngFor="let messageObj of messages" class="message-container"
       @fadeIn (mouseover)="messageObj.hover=true" (mouseleave)="messageObj.hover=false">

    <!--<particle-speech-with-action *ngIf="messageObj.type==='SpeechWithAction'"-->
    <!--[ngClass]="messageObj.isMine ? 'message-box me' : 'message-box others'"-->
    <!--[speech]="messageObj">-->
    <!--</particle-speech-with-action>-->

    <div *ngIf="messageObj.type==='SpeechWithAction'"
         [ngClass]="messageObj.isMine ? 'message-box me' : 'message-box others'">
      <span *ngFor="let richItem of richItems">
      <particle-dynamic-chat-component-viewer

        (actionPerformed)="onActionPerformed($event)"
        [data]="richItem"
      >
    </particle-dynamic-chat-component-viewer>
    </span>
    </div>
    <div *ngIf="messageObj.isDeleted"  class="deleted-text message-box me flex flex-row justify-start items-start">
      <i class="far fa-exclamation-circle"></i><span>This message has been removed</span>
    </div>
    <div
      *ngIf="!messageObj.isDeleted && (messageObj.systemMessageType === 'NON_SYSTEM_MESSAGE' || messageObj.systemMessageType === 0)"
      [ngClass]="messageObj.isMine ? 'message-box me' : 'message-box others'">
      <div class="flex flex-col">
        <!--<span>{{messageObj.createdBy.firstName}}:</span>-->
        <span
          [ngClass]="messageObj.isMine ? 'hideBlock' : 'showBlock sender'">{{messageObj.createdBy?.firstName}} {{messageObj.createdBy?.lastName}}</span>
        <span [innerHtml]="messageObj.message"></span>
        <span *ngIf="messageObj.isEdited" class="edited">(Edited)</span>
        <div class="chat-spinner" *ngIf="messageObj.isTemporary && messageObj.isMine">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
        <button mat-icon-button [matMenuTriggerFor]="msgMenu2"
                [style.visibility]="messageObj.isTemporary || messageObj.id===currentChatConversation?.initialMessage?.id? 'hidden': 'visible'"
                class="reply-menu"
                particleAnalytics
                analyticsCategory="conversation"
                analyticsAction="more-btn">
          <i class="fal fa-ellipsis-h"></i>
        </button>
        <mat-menu #msgMenu2="matMenu" [overlapTrigger]="false">
          <button mat-menu-item *ngIf="messageObj.isMine && messageObj.id!==currentChatConversation?.initialMessage?.id"
                  (click)="editMessage(messageObj)">
            <span>Edit</span>
          </button>
          <button mat-menu-item (click)="removeMessage(messageObj, true)"
                  *ngIf="messageObj.isMine && messageObj.id!=currentChatConversation?.initialMessage?.id">
            <span>Delete Message</span>
          </button>
        </mat-menu>
      </div>
      <div class="flex flex-row justify-end items-center">

        <span class="timing">
          {{messageObj.createdDate | date:'medium'}}
        </span>
      </div>
    </div>
  </div>

</div>
<particle-chat-editor
  *ngIf="!showMessageInitialization"
  [editorId]="'conversation-textarea'"
  [text]=""
  [allContacts]="[]"
  [hashTagList]="[]"
  [hideDac6CardLink]="true"
  [hideContactSuggestion]="true"
  [hideFileAttachment]="true"
  [replyToMessage]="null"
  [focusEditor$]="focusEditor$"
  [placeholder]="currentChatConversation?.waitingMessage?currentChatConversation?.waitingMessage:'Enter message...'"
  (outputChatEditorEvent)="sendMessage($event)"
>
</particle-chat-editor>
